import _ from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useMemo, useState } from 'react'
import { bindActionCreators } from 'redux'

export const useStateWithKeyPaths = (statePaths = {}) => {
	const selector = useCallback((state) => {
		return _.mapValues(statePaths, (path) => {
			return _.get(state, path)
		})
	}, [statePaths])
	const states = useSelector(selector)
	return states
}

export const useStateWithPaths = (statePaths = []) => {
	const paths = useMemo(() => statePaths, [...statePaths])
	const selector = useCallback((state) => {
		return _.map(paths, (path) => {
			return _.get(state, path)
		})
	}, [paths])
	const states = useSelector(selector)
	return states
}

export const useActions = (actionCreators = {}) => {
	const dispatch = useDispatch()
	const actions = useMemo(() => {
		return bindActionCreators(actionCreators, dispatch)
	}, _.values(actionCreators))
	return actions
}

export const useStateWithFunction = (defaultValue, method) => {
	const [state, setState] = useState(defaultValue)
	const onCallbackFunction = useCallback(
		(...args) => {
			setState(method(state, ...args))
		},
		[state, method]
	)
	return [state, onCallbackFunction, setState]
}

export default function (statePaths = [], actionCreators = {}) {
	const states = useStateWithPaths(statePaths)
	const actions = useActions(actionCreators)
	return [
		states,
		actions
	]
}